import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/main.css'

Vue.use(ElementUI, { size: 'medium' })
Vue.component('chart', ECharts)

// 全局时间过滤器（仿原项目 dataFormat）
Vue.filter('dataFormat', function (value, format) {
  if (!value) return ''
  const fmt = format || 'YYYY-MM-DD HH:mm'
  const d = new Date(Number(value))
  if (isNaN(d.getTime())) return value
  const pad = (n) => (n < 10 ? '0' + n : '' + n)
  return fmt
    .replace('YYYY', d.getFullYear())
    .replace('MM', pad(d.getMonth() + 1))
    .replace('DD', pad(d.getDate()))
    .replace('HH', pad(d.getHours()))
    .replace('mm', pad(d.getMinutes()))
})

// 图片资源统一从这里引用（打包后自动处理路径）
import imgBadminton from './assets/img/badminton.jpg'
import imgBook from './assets/img/book.jpg'
import imgFitness from './assets/img/fitness.jpg'
import imgFootball from './assets/img/football.jpg'
import imgHeadphones from './assets/img/headphones.jpg'
import imgIpad from './assets/img/ipad.jpg'
import imgJavascript from './assets/img/javascript.jpg'
import imgLibrary from './assets/img/library.jpg'
import imgMathematics from './assets/img/mathematics.jpg'
import imgMemory from './assets/img/memory.jpg'
import imgPhoto from './assets/img/photo.jpg'
import imgPortrait from './assets/img/portrait.jpg'
import imgProgramming from './assets/img/programming.jpg'
import imgSsd from './assets/img/ssd.jpg'
import noinfo from './assets/img/noinfo.png'

Vue.prototype.$img = {
  badminton: imgBadminton,
  book: imgBook,
  fitness: imgFitness,
  football: imgFootball,
  headphones: imgHeadphones,
  ipad: imgIpad,
  javascript: imgJavascript,
  library: imgLibrary,
  mathematics: imgMathematics,
  memory: imgMemory,
  photo: imgPhoto,
  portrait: imgPortrait,
  programming: imgProgramming,
  ssd: imgSsd,
  noinfo
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
